import {
  CLEAR_ALL_NOTIFICATIONS,
  CLEAR_NOTIFICATION,
  SET_NOTIFICATIONS,
} from '@store/notifications/notifications.const';

const initialState = {
  notifications: [],
};

/**
 * Notifications reducer to be combined wherever we need to.
 * @param {string} key - State slice key.
 * @returns {function(*=, *): ({notifications: *})}
 */
const reducer =
  (key = '') =>
  (state = initialState, action = { type: '', payload: null }) => {
    switch (action.type) {
      case `${key}_${SET_NOTIFICATIONS}`:
        return {
          ...state,
          notifications: [...state.notifications, ...action.payload],
        };
      case `${key}_${CLEAR_ALL_NOTIFICATIONS}`:
        return {
          ...state,
          notifications: [],
        };
      case `${key}_${CLEAR_NOTIFICATION}`:
        return {
          ...state,
          notifications: state.notifications.filter(
            notification => notification.id !== action.payload
          ),
        };
      default:
        return state;
    }
  };

export default reducer;
